module.exports = __webpack_public_path__ + "img/ttb.79929e21.svg";